export default {"src":"/_next/static/media/networking-small.5266c3db.svg","height":1000,"width":1200,"blurWidth":0,"blurHeight":0};